<div class="schedule-wrp cursorHand" (click)="goToClassOneOnOneOrGroupModeRoute(scheduleInfo)">
    <div class="schedule-card">
        <div class="d-md-flex">
          <figure><img [src]="scheduleInfo?.platformProductImage" alt="image"></figure>
          <div class="details">
            <!-- <span class="category text-uppercase">YOGA</span> -->
            <h4 class="card-title">{{scheduleInfo?.platformProductTitle}}</h4>
              <p class="desc" *ngIf="scheduleInfo?.instructorData">
                {{scheduleInfo?.instructorData[0]?.title}} {{scheduleInfo?.instructorData[0]?.firstName}} {{scheduleInfo?.instructorData[0]?.lastName}}
              </p>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center card-bottom">
          <span class="date"><span>{{ scheduleInfo?.startDate?.split("T")[0] ? scheduleInfo?.startDate?.split("T")[0] : "" }} </span>
          <span [style.margin-left]="scheduleInfo?.startDate?.split('T')[1].split('+')[0].split(':')[0] ? '10px' : '0px'">
            {{ 
              scheduleInfo?.startDate?.split("T")[1].split("+")[0].split(":")[0] ? 
              scheduleInfo?.startDate?.split("T")[1].split("+")[0].split(":")[0] +":"+ scheduleInfo?.startDate?.split("T")[1].split("+")[0].split(":")[1] :
              "" 
            }} 
            {{ 
              scheduleInfo?.startDate?.split("T")[1].split("+")[0].split(":")[0] ? 
              ( ConvertString(scheduleInfo?.startDate?.split("T")[1].split("+")[0].split(":")[0])  > 11 ? "PM" : "AM" ) :
              ""
            }}
          </span>
        </span>
          
          <!-- <span class="event" (click)="goToClassGroupModeRoute()">
            <span>{{scheduleInfo?.attendeesType}}</span>
          </span> -->
          <span *ngIf="scheduleInfo?.platformProduct === 'ONEONONE'" class="event cursorHand"  >
            <i class="icon-live"></i>
            <span>{{ scheduleInfo?.platformProduct }}</span>
          </span>
          <span *ngIf="scheduleInfo?.platformProduct === 'VOD'" class="event cursorHand"  >
            <i class="icon-group"></i>
            <span>{{ scheduleInfo?.platformProduct }}</span>
          </span>
          <span *ngIf="scheduleInfo?.platformProduct !== 'ONEONONE' && scheduleInfo?.platformProduct !== 'VOD'" class="event"  >
            <i class="icon-live"></i>
            <span>{{ scheduleInfo?.platformProduct }}</span>
          </span>
        </div>
    </div>
</div>
